module.exports = __webpack_public_path__ + "media/images/glyphicons-halflings-191ce1051bca2cdc07b6dab61240428a.png";